module.exports = __webpack_public_path__ + "static/media/IMG_3746 EDITED.df3ba3c7.JPG";